"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(Froala) {
  Froala.DefineIconTemplate('AIIconTemplate', '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 500 500" viewBox="0 0 500 500">[PATH]</svg>');
  Froala.DefineIcon('aiGenerator', {
    template: 'AIIconTemplate',
    PATH: "\n        <path d=\"M416.7 105.2H83.3c-22.9 0-41.7 18.8-41.7 41.9v206c0 22.9 18.8 41.7 41.7 41.7h333.3c22.9 0 41.7-18.7 41.7-41.7v-206c0-23.2-18.7-41.9-41.6-41.9zM270.8 332.3h-41.7v-41.7h-41.7v41.7h-41.7V165.6h125v166.7zm83.4 0h-41.7V165.6h41.7v166.7z\"/>\n        <path d=\"M187.5 207.3h41.7V249h-41.7z\"/>\n      "
  });
  Froala.RegisterCommand('aiGenerator', {
    title: 'Talk to AI',
    focus: false,
    undo: false,
    refreshAfterCallback: false,
    callback: function callback() {
      this.selection.save();
      this.opts.setIsAIModalOpen(true);
    }
  });
};

exports.default = _default;